import { SampleServiceModelBase } from "./base/sample-service-model-base";
export class SignUpSM extends SampleServiceModelBase<number>{
    firstName: string = '';
    lastName: string = '';
    email: string = ''
    contact: string = '';
    password: string = '';
  }